import { formatDate } from 'util/date';
import { getMachineType } from 'util/machine-type';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';

export const renderColumns = (t) => [
  {
    width: '20%',
    title: t('machinesRequiringAttentionTable.columns.machine'),
    dataIndex: 'machine',
    render: (machine) => {
      const { alias, materialNumber } = machine;
      return (
        <div>
          {getMachineType(materialNumber)} <br />
          {alias}
        </div>
      );
    }
  },
  {
    width: '20%',
    title: t('machinesRequiringAttentionTable.columns.materialSerialNumber'),
    dataIndex: 'machine',
    render: (machine) => {
      return `${machine.materialNumber}/${machine.serialNumber}`;
    }
  },
  {
    width: '40%',
    title: t('machinesRequiringAttentionTable.columns.description'),
    dataIndex: 'message',
    render: (message) => {
      return t(`${message}.description`, {
        ns: TRANSLATION_NAMESPACES.NOTIFICATION_CODES
      });
    }
  },
  {
    width: '20%',
    title: t('machinesRequiringAttentionTable.columns.dateRegistered'),
    dataIndex: 'createdAt',
    render: (createdAt) => {
      return formatDate(createdAt, { shortFormat: true });
    }
  }
];
